// Stub implementation for date formatter
export const formatDate = (date: Date | string) => {
  if (typeof date === 'string') {
    return new Date(date).toLocaleDateString();
  }
  return date.toLocaleDateString();
};

export const formatDateTime = (date: Date | string) => {
  if (typeof date === 'string') {
    return new Date(date).toLocaleString();
  }
  return date.toLocaleString();
};

export const formatDateToYYYYMMDD = (date: Date | string, _format?: string) => {
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toISOString().split('T')[0];
};